import Mock from './Mock';

export default class InformationPageServiceMock {
  static getOfficesInformation() {
    return Mock.call({
      email: 'info@sqc.ca',
      webSite: 'http://www.sqc.ca',
      facebook: 'http://www.facebook.com/SyndicatQuebecoisConstruction/',
      offices: [
        {
          name: 'Montréal, Montérégie, ...',
          address: {
            street: '123, Street 1',
            appartment: 'bureau 123',
            city: 'Montréal',
            postalCode: 'W1W 1E1',
            provinceCode: 'CA-QC',
            countryCode: 'CA',
          },
          phoneNumbers: [
            {
              number: '123-123-1234',
              extension: '1234',
              type: 'PHONE_NUMBER_TYPE.OFFICE',
            },
            {
              number: '123-123-1234',
              extension: '',
              type: 'PHONE_NUMBER_TYPE.OFFICE',
            },
            {
              number: '123-123-1234',
              type: 'PHONE_NUMBER_TYPE.FAX',
            },
          ],
          id: 0,
        },
        {
          name: 'Québec',
          address: {
            street: '456, Street 5',
            appartment: '',
            city: 'Québec',
            postalCode: 'W1W 1E1',
            provinceCode: 'CA-QC',
            countryCode: 'CA',
          },
          phoneNumbers: [
            {
              number: '123-123-1234',
              extension: '1234',
              type: 'PHONE_NUMBER_TYPE.OFFICE',
            },
          ],
          id: 2,
        },
        {
          name: 'Qweqwe, ...',
          address: {},
          phoneNumbers: [
            {
              number: '123-123-1234',
              type: 'PHONE_NUMBER_TYPE.OFFICE',
            },
          ],
          id: 3,
        },
      ],
    });
  }

  static getExternalDirectory() {
    return Mock.call([
      {
        name: 'Montréal, Montérégie, ...',
        email: 'info@sqc.ca',
        webSite: 'http://www.sqc.ca',
        facebook: 'http://www.facebook.com/SyndicatQuebecoisConstruction/',
        address: {
          street: '123, Street 1',
          appartment: 'bureau 123',
          city: 'Montréal',
          postalCode: 'W1W 1E1',
          provinceCode: 'CA-QC',
          countryCode: 'CA',
        },
        phoneNumbers: [
          {
            number: '123-123-1234',
            extension: '1234',
            type: 'PHONE_NUMBER_TYPE.OFFICE',
          },
          {
            number: '123-123-1234',
            extension: '',
            type: 'PHONE_NUMBER_TYPE.OFFICE',
          },
          {
            number: '123-123-1234',
            type: 'PHONE_NUMBER_TYPE.FAX',
          },
        ],
        id: 0,
      },
      {
        name: 'Québec',
        email: 'info@sqc.ca',
        webSite: 'http://www.sqc.ca',
        facebook: 'http://www.facebook.com/SyndicatQuebecoisConstruction/',
        address: {
          street: '456, Street 5',
          appartment: '',
          city: 'Québec',
          postalCode: 'W1W 1E1',
          provinceCode: 'CA-QC',
          countryCode: 'CA',
        },
        phoneNumbers: [
          {
            number: '123-123-1234',
            extension: '1234',
            type: 'PHONE_NUMBER_TYPE.OFFICE',
          },
        ],
        id: 2,
      },
      {
        name: 'AA, Qweqwe, ...',
        address: {},
        phoneNumbers: [
          {
            number: '123-123-1234',
            type: 'PHONE_NUMBER_TYPE.OFFICE',
          },
        ],
        id: 3,
      },
    ]);
  }

  static getOfficeRepresentatives() {
    return Mock.call([
      {
        id: 1,
        firstName: 'Test',
        lastName: 'Member',
        email: 'test@example.com',
        extension: 1234,
      },
      {
        id: 2,
        firstName: 'Test2',
        lastName: 'Member2',
        email: 'test2@example.com',
        extension: 5678,
      },
      {
        id: 3,
        firstName: 'Test3',
        lastName: 'Member3',
        email: 'test3@example.com',
        extension: 9000,
      },
    ]);
  }
}
